export const ZERO = 0;
export const ONE = 1;
export const NEGATIVE_ONE = -1;
